module.exports = __webpack_public_path__ + "img/ennetix-network-elements-page2.acbe71ed.png";